<template>
  <div>
    <el-select class="select-default w-full"
               :value="value"
               :loading="loading"
               :remote-method="onRemoteMethod"
               filterable
               default-first-option
               @change="onChange"
               v-bind="$attrs"
               :value-key="valueKey"
               :placeholder="$t('generic.selectUser')"
    >
      <el-option v-for="user in users"
                 class="select-default"
                 :key="user.uuid"
                 :label="getDisplayName(user)"
                 :value="user">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import throttle from 'lodash/throttle'
  import get from 'lodash/get'
  import ClientUserService from 'src/services/ClientUserService'

  export default {
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: [String, Number, Array, Object],
        default: () => null
      },
      valueName: {
        type: String,
        default: ''
      },
      searchParams: {
        type: Object,
        default: () => ({})
      },
      valueKey: {
        type: String,
        default: 'uuid'
      },
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        users: []
      }
    },
    methods: {
      getDisplayName(user) {
        let { given_name, family_name, email } = user
        if (given_name && family_name) {
          return `${given_name} ${family_name}`
        }
        return email
      },
      onChange (val) {
        this.$emit('change', val)
      },
      async searchUsers (query) {
        try {
          this.loading = true
          let { data } = await ClientUserService.get({query, limit: 50, ...this.searchParams})
          this.users = data
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      }
    },
    created () {
      this.onRemoteMethod = throttle(this.searchUsers, 200)
    },
    async mounted () {
      const name = get(this.value, 'given_name', '')
      await this.searchUsers(name)
    }
  }
</script>
<style lang="scss">
</style>
